module.exports = __webpack_public_path__ + "static/media/Q1_Back_Left.9bbbb535.png";